import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6199698f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-16 lg:py-64 flex flex-col items-center relative overflow-hidden -mb-16" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-white text-4xl lg:text-6xl mb-5 mx-4 text-center" }, [
  /*#__PURE__*/_createTextVNode(" Investigate "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-green-400 uppercase" }, "your NEAR"),
  /*#__PURE__*/_createTextVNode(" account ")
], -1))
const _hoisted_3 = { class: "text-2xl text-white lg:text-4xl mb-8" }
const _hoisted_4 = { class: "flex flex-col lg:flex-row flex-shrink-0 lg:space-x-4 items-stretch lg:items-start" }
const _hoisted_5 = { class: "flex flex-col flex-shrink-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-sm text-gray-400 text-center font-medium m-3" }, " Enter account name ", -1))
const _hoisted_7 = { class: "flex flex-col flex-shrink-0" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-sm text-gray-400 text-center font-medium m-3" }, " Select range ", -1))
const _hoisted_9 = { class: "flex flex-col flex-shrink-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-sm text-gray-400 text-center font-medium m-3" }, " Select network ", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Show stats")
const _hoisted_12 = {
  key: 0,
  class: "flex space-x-3 mt-6"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white font-medium" }, "Or try these:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_TimeframeInput = _resolveComponent("TimeframeInput")!
  const _component_NetworkInput = _resolveComponent("NetworkInput")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_account_link = _resolveComponent("account-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Chart, {
      option: _ctx.chartOption,
      class: "bg-chart",
      autoresize: ""
    }, null, 8, ["option"]),
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, " and " + _toDisplayString(_ctx.$filters.number.standard(_ctx.allAccounts)) + " other accounts ", 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_TextInput, {
          autofocus: "",
          placeholder: "my-account.near",
          class: "shadow-md",
          modelValue: _ctx.accountInputValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accountInputValue) = $event)),
          onSubmit: _ctx.go
        }, null, 8, ["modelValue", "onSubmit"]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_TimeframeInput, {
          class: "shadow-md lg:w-48",
          modelValue: _ctx.timeframeInputValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.timeframeInputValue) = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_NetworkInput, {
          class: "shadow-md lg:w-48",
          modelValue: _ctx.networkInputValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.networkInputValue) = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_10
      ]),
      _createVNode(_component_PrimaryButton, { onClick: _ctx.go }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_ctx.accountsJumble.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountsJumble.slice(0, 4), (account) => {
            return (_openBlock(), _createBlock(_component_account_link, {
              key: account,
              account: account,
              class: "truncate",
              style: {"max-width":"150px"},
              theme: "dark"
            }, null, 8, ["account"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}